"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedIssuers = void 0;
var SupportedIssuers;
(function (SupportedIssuers) {
    SupportedIssuers["ALLSTATE"] = "allstate";
    SupportedIssuers["AMERICAN_STRATEGIC"] = "americanstrategic";
    SupportedIssuers["ASSURANT"] = "assurant";
    SupportedIssuers["AUTO_OWNERS"] = "autoowners";
    SupportedIssuers["BRISTOLWEST"] = "bristolwestinsurance";
    SupportedIssuers["DAIRYLAND"] = "dairyland";
    SupportedIssuers["DIRECT_AUTO"] = "directauto";
    SupportedIssuers["ERIE"] = "erie";
    SupportedIssuers["ESURANCE"] = "esurance";
    SupportedIssuers["FARMERS"] = "farmers";
    SupportedIssuers["GEICO"] = "geico";
    SupportedIssuers["HOMESITE"] = "homesite";
    SupportedIssuers["KEMPER"] = "kemper";
    SupportedIssuers["LEMONADE"] = "lemonade";
    SupportedIssuers["LIBERTY_MUTUAL"] = "libertymutual";
    SupportedIssuers["MAPFRE"] = "mapfre";
    SupportedIssuers["MERCURY"] = "mercury";
    SupportedIssuers["MET_LIFE"] = "metlife";
    SupportedIssuers["NATIONWIDE"] = "nationwide";
    SupportedIssuers["PROGRESSIVE"] = "progressive";
    SupportedIssuers["ROOT"] = "root";
    SupportedIssuers["SAFEAUTO"] = "safeauto";
    SupportedIssuers["SAFECO"] = "safeco";
    SupportedIssuers["STATE_FARM"] = "statefarm";
    SupportedIssuers["THE_HARTFORD"] = "thehartford";
    SupportedIssuers["THE_GENERAL"] = "thegeneral";
    SupportedIssuers["TRAVELERS"] = "travelers";
    SupportedIssuers["UNIVERSAL_PROPERTY"] = "universalproperty";
    SupportedIssuers["USAA"] = "usaa";
    // Special
    SupportedIssuers["DEMO"] = "demo";
    SupportedIssuers["DUMMY"] = "dummy";
    // property issuers
    SupportedIssuers["ARROWHEAD"] = "arrowhead";
    SupportedIssuers["CABRILLO"] = "cabrillo";
    SupportedIssuers["HOMEOWNERS_OF_AMERICA"] = "homeownersofamerica";
    SupportedIssuers["NARRAGANSETT_BAY"] = "narragansettbay";
    SupportedIssuers["SAGESURE"] = "sagesureins";
    SupportedIssuers["SECURITY_FIRST"] = "securityfirst";
    SupportedIssuers["STILLWATER"] = "stillwater";
})(SupportedIssuers = exports.SupportedIssuers || (exports.SupportedIssuers = {}));
